import DayEndQueries from './DayEndQueries'

const mvPaymentDayEnd = {
  mvPaymentDayEnd: {
    ...DayEndQueries,
  }
}

export default mvPaymentDayEnd